import LNC from './lnc';

export type { LncConfig, CredentialStore } from './types/lnc';
export * from '@lightninglabs/lnc-core';
export default LNC;
